import computeClassName from "../../../../utils/computeClassName";

const constants = Object.freeze({
  CLASSNAME_BASE: ''
});

export default function IconFilter({className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" className={computedClassName}>
      <line x1="12" y1="1.5" x2="0" y2="1.5" stroke="currentColor"/>
      <circle cx="1.5" cy="1.5" r="1" fill="white" stroke="currentColor"/>
      <line x1="12" y1="6.5" x2="0" y2="6.5" stroke="currentColor"/>
      <circle cx="10.5" cy="6.5" r="1" fill="white" stroke="currentColor"/>
    </svg>

  );
}
// x2 = -4.37114e-08
